<template>
  <b-overlay
    id="overlay-background"
    :show="loading"
    blur="10px"
    opacity="0.30"
    rounded="sm"
    variant="light"
  >
    <section class="invoice-preview-wrapper font-weight-bolder">
      <b-alert
        variant="danger"
        :show="allItems === undefined"
      >
        <h4 class="alert-heading">
          No debit note found with this debit note id
        </h4>
      </b-alert>

      <b-row
        v-if="allItems"
        class="invoice-preview"
      >
        <b-col
          cols="12"
          xl="9"
          md="8"
        >
          <b-card
            id="invoice-preview-card"
            no-body
            class="invoice-preview-card"
          >
            <b-card-body class="invoice-padding pb-0 invoice-dark">
              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                <div class="logo-wrapper">
                  <img
                    style=" height: 200px; width: 200px"
                    :src="companyLogoSrc"
                    alt="Company Logo"
                  >
                </div>
                <div class="mt-md-0 mt-2 business-details">
                  <div class="invoice-title">
                    {{ allItems.business_profile.company_name }}
                  </div>
                  <div class="invoice-date-wrapper">
                    <p class="card-text mb-25">
                      {{ allItems.business_profile.company_address }}
                    </p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p class="card-text mb-0">
                      {{ allItems.business_profile.company_phone }}
                    </p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p class="card-text mb-0">
                      {{ allItems.business_profile.company_finance_email }}
                    </p>
                  </div>
                </div>
              </div>
            </b-card-body>

            <hr class="invoice-spacing">

            <b-card-body class="invoice-padding pt-0 invoice-dark">
              <b-row class="invoice-spacing merchant-detatils">
                <b-col
                  cols="12"
                  xl="6"
                  class="p-0"
                >
                  <div class="mb-1 invoice-margin invoice-dark">
                    Merchant Name:  {{ allItems.merchant.name }}
                  </div>
                  <div class="mb-1 invoice-margin invoice-dark">
                    Merchant Type:  {{ allItems.merchant.merchant_setting.merchant_type === 'credit' ? 'Credit' : 'Cash' }}
                  </div>
                  <div class="mb-1 invoice-margin invoice-dark">
                    Merchant Business:  {{ allItems.merchant_business }}
                  </div>
                  <div class="mb-1 invoice-margin invoice-dark">
                    Merchant Address:  {{ allItems.address.address_line_1 + allItems.address.address_line_2 + allItems.address.address_line_3 }}
                  </div>
                </b-col>
                <b-col
                  xl="6"
                  cols="12"
                  class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end invoice-number"
                >
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">
                            <span class="font-weight-bolder">
                              Debit Note No:
                            </span>
                          </td>
                          <td><span class="font-weight-bolder">{{ allItems.debit_note_no }}</span></td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            <span class="font-weight-bolder">
                              Debit Note Date:
                            </span>
                          </td>
                          <td><span class="font-weight-bolder">{{ __dateTimeFormatter(allItems.updated_at) }}</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <b-table-lite
              class="delivery-management-service-table invoice-des-tb"
              responsive
              :items="rows"
              :fields="invoiceTableStructure"
            >
              <template #cell(card_name)>
                Delivery Management Service
              </template>
              <template #cell(invoice_count)>
                {{ (allItems.invoices || []).length }}
              </template>
              <template #cell(return_charge)="data">
                {{ __numberWithCommas(data.value, true) }}
              </template>
              <template #cell(return_rate)="data">
                {{ __numberWithCommas(data.value, true) }}
              </template>
              <template #cell(debit_amount)="data">
                <div>
                  {{ __numberWithCommas(data.value, true) }}
                </div>
              </template>
            </b-table-lite>

            <b-card-body class="invoice-padding pb-0 invoice-dark">
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                  class="mt-md-6 d-flex"
                  order="1"
                  order-md="2"
                >
                  <div>
                    <table class="account-statment-table">
                      <tbody>
                        <tr>
                          <td class="pr-1">
                            <div class="mb-1 account-statement invoice-dark">
                              {{ allItems.business_profile.company_name }} Account Statement
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Return Charge
                          </td>
                          <td class="w-50 pl-2 text-right finance-section">
                            <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(allItems.return_charge, true) }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Return Rate
                          </td>
                          <td class="w-50 pl-2 text-right finance-section">
                            <span>{{ __numberWithCommas(allItems.return_rate, true) }}</span>
                          </td>
                        </tr>
                        <br>
                        <tr>
                          <td class="pr-1">
                            <div class="">
                              Debit Note Total
                            </div>
                          </td>
                          <td class="w-50 pl-2 text-right finance-section">
                            <span>{{ businessSettings.company_currency }} {{ __numberWithCommas(allItems.debit_amount, true) }}</span>
                          </td>
                        </tr>
                        <hr class="invoice-spacing">
                        <tr>
                          <td class="pr-1">
                            -----------------------------
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <span class="font-weight-bolder">Head of Finance</span>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <hr class="invoice-spacing">

            <b-card-body class="invoice-padding pt-0 invoice-dark">
              <span class="font-weight-bolder">Remarks: </span>
              <br>
              <span>* If you need any clarifications on this. please do not hesitate to contact the head of finance.</span>
              <br>
              <span>* Please refer the annexure for more details attached herewith.</span>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col
          cols="12"
          md="4"
          xl="3"
          class="invoice-actions"
        >
          <b-card>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-success"
              class="mb-75"
              block
              @click="printDebitNote"
            >
              Print
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BButton,
  BAlert,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { bucketUrl, defaultCompanyLogo } from '@/constants/config'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Printd from 'printd'

const FinanceRepository = RepositoryFactory.get('finance')

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BButton,
    BAlert,
    BOverlay,
  },
  data() {
    return {
      loading: false,
      id: null,
      allItems: null,
      rows: [],
      bucketUrl,
      defaultCompanyLogo,
      businessSettings: null,
      invoiceTableStructure: [
        {
          key: 'card_name',
          label: 'Name',
        },
        {
          key: 'invoice_count',
          label: 'Invoice Count',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'return_charge',
          label: 'Return Charge',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'return_rate',
          label: 'Return Rate',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'debit_amount',
          label: 'Debit Note Total',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
      ],
      cssText: `
      body {
        background-color: transparent !important;
      }
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      b {font-weight:500; }
      .invoice-preview-card {
        font-family:Montserrat,Helvetica,Arial,serif;
        font-size:12px;
        font-weight:600;
      }
      .invoice-title {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 1rem;
      }
      .delivery-management-service-table th {
        text-align: left;
        border-top: 1px solid #ebe9f1;
        border-bottom: 1px solid #ebe9f1;
        padding: 12px 8px;
        text-transform: uppercase;
      }
      .delivery-management-service-table td {
        padding: 12px 8px;
        text-align: right;
      }
      .delivery-management-service-table th:first-child,
      .delivery-management-service-table td:first-child {
        text-align: left;
        width: 100px;
      }
      .table {
        th:first-child,
        td:first-child {
          padding-left: 2.5rem;
        }
      }
      .account-statement {
        margin-top: 8px;
        margin-bottom: 8px;
        width: 150px;
      }
      .account-statment-table td {
        width: 150px;
      }
      .invoice-margin {
        margin-bottom: 1rem;
      }
      .business-details{
        margin-top: 20px;
        margin-bottom: 20px;
      }
      hr {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
      }
      .merchant-detatils {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
        display: flex !important;
        flex-wrap: wrap !important;
      }
      .invoice-number {
        display: flex !important;
        margin-left: auto !important;
      }
      .invoice-padding {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
      }
      .content.app-content {
        margin-left: 0;
        padding-top: 2rem !important;
      }
      .card {
        background-color: transparent;
        box-shadow: none;
      }
      .invoice-spacing {
        margin: $invoice-spacing;
      }
      .invoice-preview-wrapper {
        .row.invoice-preview {
          .col-md-8 {
            max-width: 100%;
            flex-grow: 1;
          }

          .invoice-preview-card {
            .card-body:nth-of-type(2) {
              .row {
                > .col-12 {
                  max-width: 50% !important;
                }

                .col-12:nth-child(2) {
                  display: flex;
                  align-items: flex-start;
                  justify-content: flex-end;
                  margin-top: 0 !important;
                }
              }
            }
          }
        }
      }
      .finance-section {
        text-align: right;
        width: 50px;
      }`,
    }
  },
  computed: {
    companyLogoSrc() {
      const logo = this.allItems && this.allItems.business_profile && this.allItems.business_profile.company_logo
      if (!logo) return this.defaultCompanyLogo
      if (logo.startsWith('http')) return logo
      return `${this.bucketUrl}${logo}`
    },
  },
  async created() {
    this.id = this.$route.params.id
    this.businessSettings = JSON.parse(localStorage.getItem('businessSettings'))
  },
  async mounted() {
    await this.fetchDataForDebitNote()
  },
  methods: {
    async fetchDataForDebitNote() {
      try {
        this.loading = true
        const { data } = (await FinanceRepository.getDebitNoteData(this.id)).data
        this.allItems = data
        this.rows = [{
          invoice_count: (data.invoices || []).length,
          return_charge: data.return_charge,
          return_rate: data.return_rate,
          debit_amount: data.debit_amount,
        }]
      } catch (e) {
        this.convertAndNotifyError(e)
        this.allItems = undefined
        this.rows = []
      }
      this.loading = false
    },
    printDebitNote() {
      const printd = new Printd()
      printd.print(document.getElementById('invoice-preview-card'), [this.cssText])
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  @page {
    size: A4
  }
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    .invoice-actions {
      display: none;
    }
  }
}
</style>
